import type { UseFetchOptions } from 'nuxt/app'
import { useLogger } from './useLogger'
import { useApiService } from './useApiService'

export interface ConfigRequest {
  userId: string | null;
  creationDate: string | null; // ISO 8601 timestamp or null
  helperId: string | null; // Helper ID if available
  helperEmail: string | null; // Helper email if available
}

export function useCentralConfigService() {
  const logger = useLogger()
  const { makeApiCall } = useApiService()

  const fetchConfig = async (configRequest: ConfigRequest, options?: UseFetchOptions<any>) => {
    logger.debug('CentralConfigService: Fetching configuration for user:', configRequest)
    
    try {      
      const response = await makeApiCall<ConfigRequest, any>(
        'central-config',
        configRequest,
        'CentralConfigService',
        options
      )
      
      logger.info('CentralConfigService: Configuration fetched successfully')
      return response
    } catch (error: any) {
      logger.error('CentralConfigService: Failed to fetch configuration:', error)
      
      if (error.statusCode === 400) {
        throw new Error('Invalid user ID for configuration request')
      }
      
      throw new Error(`Failed to fetch configuration: ${error.message || 'Unknown error'}`)
    }
  }

  return {
    fetchConfig
  }
} 